import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";

import { MediaObject } from "../basic/media-object-list.js";
import { CollectionName } from "../basic/collection-name.js";

import { DfpAd } from "../dfp-ad";

export function FullscreenStoryList(props) {
  if (props.stories.length < 1) return <div />;

  const mediaObjectConfig = {
    section: !props.hideSectionName,
    enlarged: true,
    noBackground: true,
    storyTime: true,
    aspectRatio: [5, 3],
    widths: [96, 192, 258],
    sizes: "(max-width: 500px) 96px, (max-width: 768px) 96px, 258px"
  };
  const collectionName = get(props.associatedMetadata, ["show_collection_title"], true);

  return (
    <div className="fullscreen-media-list" data-test-id="fullscreen-story-list-component">
      <div className="fullscreen-media-list__content component-wrapper">
        {collectionName ? (
          <CollectionName
            className="fullscreen-media-list__section-name"
            name={props.config["collection-name"]}
            type="large"
            section={props.config["collection-section"] || props.collection}
          />
        ) : null}
        <div className="fullscreen-media-list__stories">
          {props.stories.map(storyObj => {
            const story = storyObj && storyObj.story ? storyObj.story : storyObj;
            return (
              <div className="fullscreen-media-list__object" key={story.id}>
                <MediaObject story={story} config={mediaObjectConfig} sectionColor={props.config["collection-color"]} />
              </div>
            );
          })}

          {(props.associatedMetadata ? props.associatedMetadata.enable_load_more_button === true : true) &&
            !props.noMoreStories && (
              <div className="load-more">
                <button onClick={props.onLoadMore}>Load More</button>
              </div>
            )}
        </div>
        <div className="ad-container">
          <div className="app-ad app-ad--vertical">
            <DfpAd adtype="Vertical-Ad" />
          </div>
        </div>
      </div>
    </div>
  );
}
